export function BrandMark() {
  return (
    <a className="brand-mark" href="/" aria-label="PlayerUp home">
      <span className="brand-mark__symbol" aria-hidden="true">
        P
      </span>
      <span className="brand-mark__word">PlayerUp</span>
    </a>
  );
}
